<app-navbar></app-navbar>
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div>
                    <h3 class="display-2 mt-5 lh-base fw-semibold"><span class="text-muted">Sorry!,</span> this page isn't available</h3>
                    <div class="inter fs-2 fw-semibold text-muted mb-2 mt-2">The page you looking for couldn't be found.</div>
                    <div class="inter pt-5  fs-5">Go back to the <a [routerLink]="['/']" class="text-decoration-none text-secondary">home page</a> or <a [routerLink]="['/contacts']" class="text-decoration-none text-secondary">contact us.</a></div>
                </div>
            </div>
            <div class="col-lg-6">
                <img src="assets/404.png" class="mt-5 pt-4">
            </div>
        </div>
    </div>
<app-footer></app-footer>